/* eslint-disable jsx-a11y/alt-text */
import { createColumnHelper } from "@tanstack/react-table";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchProductCodeManagementDownload,
  useProductCodeManagementList,
} from "../../../../api/product-code-management/use-product-code";
import { FallbackImage } from "../../../../assets/img";
import Table from "../../../../components/ui/Table/Table";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexVal =
          page === 1 ? total - index : total - index - (page - 1) * pageSize;

        return <div>{indexVal}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productNo, {
      header: "상품번호",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.mainImage, {
      header: "이미지",
      cell: (info) => {
        const val = info.getValue();
        const handleError = ({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = FallbackImage;
        };
        return (
          <div className="m-auto w-[100px] h-[100px] flex justify-center">
            <img
              className="m-auto w-[85px] h-[85px] border border-primary-grey object-cover"
              src={val}
              onError={handleError}
            />
          </div>
        );
      },
    }),

    columnHelper.accessor((row) => row?.productGroupCategory, {
      header: "카테고리",
      cell: (info) => {
        const val = info.getValue().name;
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row, {
      header: "상품 그룹명",
      cell: (info) => {
        const val = info.getValue().name;
        const name = val?.length > 25 ? val?.substring(0, 25) + "..." : val;
        return <div>{name ? name : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.productQty, {
      header: "등록 상품 수",
      cell: (info) => {
        const val = info.getValue();
        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.qrQty, {
      header: "등록 QR 수",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              val === 0 ? (
                <span className="text-[#FF0000]">{val}</span>
              ) : (
                <span>{val}</span>
              )
            ) : (
              <span className="text-[#FF0000]">0</span>
            )}
          </div>
        );
      },
    }),

    columnHelper.display({
      header: "관리",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

const sorts = [
  {
    id: "",
    name: "최신순",
  },
  {
    id: "CREATED_AT_DESC",
    name: "등록일순",
  },
  {
    id: "PRODUCT_QTY_DESC",
    name: "등록 상품 수 순",
  },
  {
    id: "LATEST_ORDER",
    name: "등록 QR 수순",
  },
];

export function CodeManagementTable(props) {
  const { filter, onSort, isResettedPage } = props;
  const { isEmpty, getDataTableProps } = useProductCodeManagementList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  const onSave = async () => {
    await fetchProductCodeManagementDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `product-code-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {isEmpty ? (
        <>
          <div className="flex justify-center mt-[60px] text-[#999999] text-center">
            <span>
              등록된 상품이 없습니다. <br />
              상품등록을 완료해야만 코드관리의 정보가 등록됩니다.
            </span>
          </div>
          <div className="flex justify-center">
            <button className="mt-6 rounded-3xl flex justify-center w-[15rem] border border-[#333333] p-2">
              상품 조회 이동
            </button>
          </div>
        </>
      ) : (
        <>
          <Table
            onSave={onSave}
            onSort={onSort}
            sorts={sorts}
            columns={columns(currentPage, pageSize, totalData)}
            width="w-28"
            isResettedPage={isResettedPage}
            {...getDataTableProps()}
          />
        </>
      )}
    </>
  );
}
